import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Observable, of } from 'rxjs';
import { AbstractFormComponent } from 'src/app/common/abstract-edit.component';
import { PARAM_BOOKINGS_TYPE_PATH, STATE_LIST } from 'src/app/constants/constants';
import { Booking_type } from 'src/app/models/booking_type';
import { BookingTypeService } from 'src/app/services/booking_type.service';
import { Bind } from 'primeng/bind';
import { ButtonDirective } from 'primeng/button';
import { Card } from 'primeng/card';
import { InputText } from 'primeng/inputtext';

import { SelectButton } from 'primeng/selectbutton';
import { Toast } from 'primeng/toast';
import { TranslatePipe } from '@ngx-translate/core';

import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-booking-type-form',
    templateUrl: './booking-type-form.component.html',
    imports: [TPipe, FormsModule, ReactiveFormsModule, Bind, ButtonDirective, RouterLink, Card, InputText, SelectButton, Toast, TranslatePipe]
})
export class BookingTypeFormComponent extends AbstractFormComponent<Booking_type> implements OnInit {
  protected fb: FormBuilder;
  private bookingTypeService = inject(BookingTypeService);

  pageTitle: string;
  form: FormGroup;
  idField = 'id';
  formFields = ['id', 'name', 'description', 'is_active'];
  item$: Observable<Booking_type> = of();
  stateOptions = STATE_LIST;
  service = this.bookingTypeService;

  constructor() {
    const fb = inject(FormBuilder);
    const messageService = inject(MessageService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(fb, messageService, confirmationService, router, route, PARAM_BOOKINGS_TYPE_PATH);

    this.fb = fb;
  }

  ngOnInit() {
    this.initializeForm();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.pageTitle = 'Modifica Tipo di Prenotazione';
      this.loadItem(id);
    } else {
      this.pageTitle = 'Aggiungi Tipo di Prenotazione';
    }
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      description: [''],
      is_active: ["0"]
    });
  }

  loadItem(id: string) {
    this.service.getId(id).subscribe(
      res => {
        this.form.patchValue({
          name: res.name,
          description: res.description,
          is_active: res.is_active,
          id: res.id
        });
      },
      error => this.error = error
    );
  }
}

